import React, { useEffect, useState, useContext } from "react";
import { Button, Row, Col, Radio, Form, Input, Select, message } from 'antd';
import moment from "moment";
import Ihoten from './../../../../src/assets/pvi-benhhiemngheo/ihoten.svg';
import Iphone from './../../../../src/assets/pvi-benhhiemngheo/idienthoai.svg';
import Ithoigian from './../../../../src/assets/pvi-benhhiemngheo/ithoigian.svg';
import Icmnd from './../../../../src/assets/pvi-benhhiemngheo/icmnd.svg';
import Iemail from './../../../../src/assets/pvi-benhhiemngheo/iemail.svg';
import Idiachi from './../../../../src/assets/pvi-benhhiemngheo/idiachi.svg';
import Goi1 from "./../../../../src/assets/pvi-benhhiemngheo/goi1.svg";
import Goi2 from "./../../../../src/assets/pvi-benhhiemngheo/goi2.svg";
import Goi3 from "./../../../../src/assets/pvi-benhhiemngheo/goi3.svg";
import Goi4 from "./../../../../src/assets/pvi-benhhiemngheo/goi4.svg";
import MdRene from "./../modalnotification/modalConfirmRenewals";
import Service from "./../../../extra/getAPI";
import DatePicker from "../modalnotification/DatePicker";
import Helper from "./../../../extra/helper";
import { AuthContext } from './../index';

const InforBuyer = () => {
  const { listIsu, goStep, ActionList, dataRenewals, CheckRenewals, Back, getAge, toltalFees } = useContext(AuthContext);
  const { Option } = Select;
  const [formData, setFormData] = useState({});
  const [datePicker, setDatePicker] = useState({});
  const [listInsured, setListInsured] = useState([]);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [listPackageInsuAPI, setListPackageInsuAPI] = useState([]);
  const img = [Goi1, Goi2, Goi3, Goi4];
  const earlyStage = [37500000, 75000000, 150000000, 300000000];
  const lateStage = [150000000, 300000000, 600000000, 1200000000];
  const charges = [250000, 500000, 1000000, 2000000];
  const compensation = [6250000, 12500000, 25000000, 50000000];
  const [isModalVisibleRene, setIsModalVisibleRene] = useState(false);
  const [datastep, setDatastep] = useState({});
  const [loading, setLoading] = useState(false);
  const [fees, setFees] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    form.setFieldsValue({ "relationshipWithBuyerId": 1 });
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    if (dataIsu) {
      setFormData(dataIsu);
      form.setFieldsValue(dataIsu || {});
      // if (dataIsu.buyfor === 1) {
      //   CheckRenewals(dataIsu.insuredDob, dataIsu.insuredPrivateId);
      // }
      setTimeout(() => {
        // console.log(moment().diff(dataIsu.insuredDob, 'years'));
        if (getAge(dataIsu.insuredDob) < 16) {
          form.setFieldsValue({ 'insuredDob': '' });
        }
        // if (+dataIsu?.yearsOfInsurance > 1 && (getAge(dataIsu?.insuredDob) > 55)) {
        //   form.setFieldsValue({ 'insuredDob': '' });
        // }
      }, 200);
    }
  }, []);

  const onFinish = (val) => {
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    form
      .validateFields()
      .then(async (values) => {
        let item = {
          ...values,
          // listPackageInsu: listPackageInsuAPI,
          fees: fees
        }
        setDatastep(item);
        localStorage.setItem('databuyer', JSON.stringify(item));
        setTimeout(() => {
          localStorage.setItem('dataIsu',
            JSON.stringify({
              ...dataIsu,
              ...values,
              // listPackageInsu: listPackageInsuAPI,
              fees: fees
            })
          )
          setFormData(values || {});
        }, 100);

        if (values.buyfor === 1) {
          addBuyerTolist(item);
          // // Nếu tuổi hợp lệ và không phải đơn tái tục thì vẫn cho qua bình thường
          // if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 0) {
          //   addBuyerTolist(item);
          //   // Nếu tuổi hợp lệ và  đơn tái tục thì hiện thông báo xác nhận
          // } else if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 1) {
          //   setIsModalVisibleRene(true);
          // } else {
          //   message.warning({
          //     content: 'Tuổi của bạn không phù hợp nếu là người được bảo hiểm!',
          //     style: {
          //       marginTop: '2vh',
          //     },
          //   }, 10);
          // }
        } else {
          setTimeout(() => { goStep(5) }, 100);
        }
      })
      .catch((err) => {
        console.error('err:', err);
      });
  };

  const ConfirmRene = (key) => {
    setIsModalVisibleRene(!isModalVisibleRene);
    if (key === 'yes') {
      addBuyerTolist(datastep)
    }
  }

  const addBuyerTolist = (item) => {
    if (listIsu[0]?.relationshipWithBuyerId !== 1) {
      ActionList('unshift', '', item);
    } else {
      ActionList('edit', 0, item);
    }
    setTimeout(() => { goStep(5); }, 100);
  }

  const handleCancelRene = () => {
    setIsModalVisibleRene(false);
  };

  const getFees = async () => {
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    const param = {
      yearsOfInsurance: dataIsu.yearsOfInsurance,
      packageId: dataIsu.package,
      listOfInsuredPeople: [
        {
          insuredDob: moment(formData?.insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
          insuredGender: +formData?.insuredGender
        }
      ]
    };
    const res = await Service.apicall(
      "POST",
      `/v1/products/critical-disease/fees`,
      param
    );
    setFees(res?.data?.data?.fees);
  };

  useEffect(() => {
    if (formData?.insuredDob && formData?.insuredGender && formData.yearsOfInsurance) {
      // if (getAge(formData?.insuredDob) >= 16) {
      //   getFees();
      // }
        getFees();
    }
  }, [formData.insuredDob, formData.insuredGender, formData.yearsOfInsurance]);

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '14px 10px', position: 'absolute', zIndex: 2 }
  }

  return (
    <div style={{ fontSize: 14, background: '#EDEFFA', height:'100vh'}}>
      {
        isModalVisibleRene &&
        <MdRene ConfirmRene={ConfirmRene} handleCancel={handleCancelRene} isModalVisible={isModalVisibleRene} />
      }
      {datePicker.open && (
        <DatePicker
          onConfirm={(data) => {
            form.setFieldsValue({ "insuredDob": data });
            onChangForm({ data, name: "insuredDob" });
            // CheckRenewals(data, formData.insuredPrivateId);
          }}
          // max={moment().subtract(16, "y").toDate()}
          // // min={moment().add(1, "d").subtract(+formData?.yearsOfInsurance === 1 ? 65 : 55, "y").toDate()}
          // min={moment().add(1, "d").subtract(55, "y").toDate()}
          max={moment().add(1, 'd').subtract(15, "y").toDate()}
          min={moment().add(2, 'd').subtract(55, "y").toDate()}
          visible={datePicker.open}
          close={() => {
            setDatePicker({ ...datePicker, open: false });
          }}
          value={formData.insuredDob}
        />
      )}
      <Form
        ref={formRef}
        form={form}
        onFinish={onFinish}
        name="Serach_account"
        scrollToFirstError
      >
        <Row>
          <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff' }} xs={24}>
            <div style={{ fontWeight: 600, padding: '2% 3%' }}>Thông tin người mua bảo hiểm</div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%', position: 'relative' }}>
              <div style={css.titleInput}>Họ và tên<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
              <Form.Item
                name="insuredName"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin',
                },
                {
                  min: 5,
                  message: 'Họ tên tối thiểu phải 5 ký tự',
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  style={{ ...css.input, textTransform: 'capitalize' }}
                  placeholder='Nhập họ và tên'
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ padding: "2% 3% 0px 3%", background: '#ffffff', display: 'flex' }} xs={24}>
            <div style={{ width: "50%", marginRight: 5 }}>
              <div
                style={{ position: "relative" }}
              >
                <div style={css.titleInput}>Ngày sinh <span style={{ color: 'red' }}>*</span></div>
                <img
                  style={css.iconInput}
                  src={Ithoigian}
                  alt="quyen loi"
                />
                <Form.Item
                  name="insuredDob"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn và nhập thông tin",
                    },
                  ]}
                  style={css.FormItemsHolder}
                >
                  <Input
                    autoComplete="off"
                    readOnly
                    style={{ ...css.input, paddingRight: "6px" }}
                    placeholder="DD/MM/YYYY"
                    onClick={() => {
                      setDatePicker({ ...datePicker, open: true });
                    }}
                  />
                </Form.Item>
              </div>
            </div>
            <div style={{ width: "50%", marginLeft: 5 }}>
              <div style={{ padding: "0px", position: "relative" }}>
                <div style={css.titleInput}>Giới tính<span style={{ color: 'red' }}>*</span></div>
                <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
                <Form.Item
                  name="insuredGender"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn và nhập thông tin",
                    },
                  ]}
                  style={css.FormItemsHolder}
                >
                  <Select
                    className="custom-select-antd-padding"
                    // showSearch
                    autoComplete="off"
                    // allowClear={true}
                    placeholder="Chọn giới tính"
                    onChange={(e) => {
                      onChangForm({ data: e, name: "insuredGender" });
                    }}
                  >
                    <Option value={1}>Nam</Option>
                    <Option value={2}>Nữ</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%', position: 'relative' }}>
              <div style={css.titleInput}>Số điện thoại<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Iphone} alt="điện thoại" />
              <Form.Item
                name="buyerPhone"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập SĐT định dạng số, không bao gồm ký tự đặc biệt.',
                    pattern: /((09|03|07|08|05)+([0-9]{8})\b)/
                  }
                ]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  style={css.input}
                  placeholder='Nhập số điện thoại'
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%', position: 'relative' }}>
              <div style={css.titleInput}>CMND/ CCCD/ Hộ chiếu<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Icmnd} alt="cmnd" />
              <Form.Item
                name="insuredPrivateId"
                rules={[{
                  required: true,
                  message: 'Vui lòng nhập CMND/CCCD 9 số hoặc 12 số, không bao gồm ký tự đặc biệt.',
                  pattern: /^[A-Z][0-9]{7}$|^[0-9]{9}$|^[0-9]{12}$/
                }]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  onChange={(e) => {
                    onChangForm({ data: e.target.value, name: "insuredPrivateId" });
                    // CheckRenewals(formData.insuredDob, e.target.value);
                  }}
                  style={css.input}
                  placeholder='Nhập CMND, CCCD hoặc Hộ chiếu'
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%', position: 'relative' }}>
              <div style={css.titleInput}>Email<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Iemail} alt="email" />
              <Form.Item
                name="buyerEmail"
                rules={[{
                  required: true,
                  message: 'Email không hợp lệ',
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                }]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  style={css.input}
                  placeholder='Nhập Email'
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%', position: 'relative' }}>
              <div style={css.titleInput}>Địa chỉ liên hệ</div>
              <img style={css.iconInput} src={Idiachi} alt="địa chỉ" />
              <Form.Item
                name="buyerAddress"
                rules={[{
                  required: false,
                  message: 'Vui lòng chọn và nhập thông tin',
                },
                {
                  min: 5,
                  message: 'Địa chỉ tối thiểu phải 5 ký tự',
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  style={css.input}
                  placeholder='Nhập địa chỉ liên hệ'
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff', marginBottom: 10 }} xs={24}>
            <div style={{ padding: '2% 3% 2% 3%', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between' }}>
              <span>Mức phí bảo hiểm:</span>
              <span>{fees} VNĐ</span>
            </div>
          </Col>
          <Col style={{ background: '#ffffff', marginBottom: 120 }} xs={24}>
            <div style={{ padding: '2% 3% 2% 3%' }}>
              <div>Bạn mua bảo hiểm cho ai?</div>
              <Form.Item
                name="buyfor"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin'
                }]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} >
                      <Radio value={1}>Mua cho bản thân</Radio>
                    </Col>
                    <Col xs={12}>
                      <Radio value={2}>Mua cho người thân</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <Col xs={24} style={{ display: 'none' }}>
            <Form.Item
              name="relationshipWithBuyerId"
              rules={[{
                required: false,
                message: 'Vui lòng chọn và nhập thông tin',
              }]}
              style={css.FormItemsHolder}
              value="1"
            >
              <Input autoComplete="off"
                style={css.input}
                placeholder='Nhập địa chỉ liên hệ'
              />
            </Form.Item>
          </Col>
          <div style={{ borderRadius: '16px 16px 0px 0px', justifyContent: 'center', padding: '16px 18px 20px 18px', boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)', width: '100%', background: '#ffffff', zIndex: 10, position: 'fixed', bottom: 0, maxWidth: 800}}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={() => { Back() }} size="large" style={{ fontSize: 14, background: '#fff', color: '#2A3790', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Quay lại
              </Button>
              <Button loading={loading} onClick={() => { onFinish() }} size="large" style={{ fontSize: 14, background: '#2A3790', color: '#ffffff', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Tiếp tục
              </Button>
            </div>
          </div>
        </Row>
      </Form>
    </div >
  );
};

export default InforBuyer;
